import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import config from '../../config';

const { publicAssetUrl } = config;

type SidebarFooterProps = {
  className?: string;
  isOpen?: boolean;
};

const SidebarFooter = ({ className, isOpen }: SidebarFooterProps) => {
  const { t } = useTranslation();
  return (
    <footer
      className={classNames('text-primary', isOpen ? 'open' : '', className)}
    >
      {isOpen && (
        <p className="name text-primary">
          {t('sidebar.footer.customerExperience')}
        </p>
      )}
      {!isOpen && (
        <div className="grid grid-cols-1 gap-3 text-primary">
          <img
            className="w-7 h-7"
            src={`${publicAssetUrl}/brand/logo-icon-primary.svg`}
            alt="Logo"
          />
          <p className="font-medium text-primary">{t('sidebar.footer.cx')}</p>
        </div>
      )}
    </footer>
  );
};

export default SidebarFooter;
